<template>
    <page-parts :items="pageParts"/>
</template>

<script>

export default {
    name: "RouteRootComponent",

    computed: {
        pageParts() {
            let pageData = this.$store.getters.getPageData(this.$route);

            return pageData && pageData.page && pageData.page.treePageParts;
        },
    },
}
</script>